<div class="d-flex align-items-center flex-column badge">
  <div class="badge-header p-3">
    <p class="title">{{title}}</p>
  </div>
  <div class="badge-body p-4">
    <p class="content">{{content}}</p>
  </div>
</div>